var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-container"},[(_vm.embedId)?_c('iframe',{attrs:{"src":_vm.embedId,"frameborder":"0","allowfullscreen":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }